import type { WithdrawResponse } from "@jti/evo-client/v5";
import { createEvoClient, createWithdraw } from "@jti/evo-client/v5";
import { getConfig } from "@jti/fe-common";

import { getUser } from "../../utils";

export type WithdrawalRequestPayload = {
  orderId: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
};

const createClient = () => {
  const config = getConfig();
  const user = getUser();

  return createEvoClient({
    baseUrl: config.EVO_DOMAIN,
    recaptchaId: config["X-RECAPTCHA-ID"],
    tenantToken: config.EVO_TENANT,
    ciamToken: user.ciam_token,
    throwOnError: true,
  });
};

export const fetchWithdrawalRequest = async (payload: WithdrawalRequestPayload): Promise<WithdrawResponse | null> => {
  const client = createClient();

  const response = await createWithdraw({
    client,
    body: {
      order_id: payload.orderId,
      ...(payload.firstName && { first_name: payload.firstName }),
      ...(payload.lastName && { last_name: payload.lastName }),
      ...(payload.email && { email: payload.email }),
      ...(payload.phone && { phone: payload.phone }),
    },
    throwOnError: true,
  });

  return response.data ?? null;
};
